var map = {
	"./Forme_1.png": 1631,
	"./Forme_3.png": 229,
	"./arrow-down.png": 1632,
	"./attente.png": 1633,
	"./barratio.jpeg": 1634,
	"./bell-alarm-symbol.png": 1635,
	"./bfast.png": 1636,
	"./bouteille.png": 516,
	"./burger.png": 517,
	"./checked.png": 223,
	"./chevron-down-icon.png": 360,
	"./chevron-up-icon.png": 518,
	"./clipboard.png": 1637,
	"./copied.png": 519,
	"./copy.png": 520,
	"./easilys.jpg": 1638,
	"./fleche rouge.png": 1639,
	"./gift-icon.png": 1640,
	"./gift_.png": 1641,
	"./gstock.png": 1642,
	"./guestonline.png": 1643,
	"./guestonline2.png": 1644,
	"./help.svg": 1645,
	"./illus-niveau1-partenaire.svg": 1646,
	"./info.png": 521,
	"./logo-text-white.png": 1647,
	"./logo.png": 1648,
	"./logo_plein.png": 513,
	"./logo_symbol.png": 185,
	"./netresto.jpg": 1649,
	"./netresto.png": 1650,
	"./nonintegrated.png": 225,
	"./pause.png": 224,
	"./ronds-confirmation-formulaire.svg": 514,
	"./snapshift.png": 1651,
	"./the_fork.png": 1652,
	"./userborder.svg": 228,
	"./validé.png": 1653,
	"./verre.png": 515,
	"./zenchef.png": 1654,
	"./zenchef2.jpg": 1655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;